import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

import type { WorkspaceProfileFormValues } from "./workspace-profile-schema";
import type { UseFormReturn } from "react-hook-form";

interface CurrentWorkspaceEditDialogProps {
  form: UseFormReturn<WorkspaceProfileFormValues>;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  isUpdating: boolean;
}

export function CurrentWorkspaceEditDialog({
  form,
  isOpen,
  onOpenChange,
  onSubmit,
  isUpdating,
}: CurrentWorkspaceEditDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Edit Informasi Toko / Workspace</DialogTitle>
          <DialogDescription className="text-xs">
            Ubah nama atau kode slug outlet yang sedang aktif.
          </DialogDescription>
        </DialogHeader>

        <Form {...form}>
          <form
            id="edit-workspace-form"
            onSubmit={onSubmit}
            className="space-y-4 py-2"
          >
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Nama Outlet / Workspace</FormLabel>
                  <FormControl>
                    <Input
                      placeholder="Contoh: JAM Coffee - Cabang Utama"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="slug"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Slug URL / Identifier</FormLabel>
                  <FormControl>
                    <Input placeholder="contoh: jam-coffee-utama" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </form>
        </Form>

        <DialogFooter className="flex flex-row items-center justify-end gap-3 sm:gap-3">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isUpdating}
          >
            Batal
          </Button>
          <Button
            type="submit"
            form="edit-workspace-form"
            disabled={isUpdating}
          >
            {isUpdating ? "Menyimpan..." : "Simpan Perubahan"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
